import { render, staticRenderFns } from "./StockCreateEdit.vue?vue&type=template&id=09a0b1c5&scoped=true"
import script from "./StockCreateEdit.vue?vue&type=script&lang=js"
export * from "./StockCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./StockCreateEdit.vue?vue&type=style&index=0&id=09a0b1c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0b1c5",
  null
  
)

export default component.exports